import React, { useState, useMemo } from 'react'
import BlogList from './BlogList';
import { useSelector } from 'react-redux';

const Home = () => {
  const blogs = useSelector((state) => state.blog.blogs);
  const [search, setSearch] = useState('');

  const filteredBlogs = useMemo(() => {
    if (!search) return blogs;
    return blogs.filter(blog => 
      blog.title.toLowerCase().includes(search.toLowerCase()) || 
      blog.author.toLowerCase().includes(search.toLowerCase())
    );
  }, [blogs, search]);

  return (
    <div className='Home space-y-8'>
      {/* Hero / Search Section */}
      <div className="space-y-4 mb-10 text-left">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-800 tracking-tight">
          Welcome to <span className="text-primary">Dojo Blog</span>
        </h1>
        <p className="text-slate-500 text-lg max-w-2xl">
          Discover stories, thinking, and expertise from writers on any topic.
        </p>
        
        <div className="max-w-md relative pt-4">
          <input
            type="text"
            placeholder="Search blogs by title or author..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-5 py-3 pl-12 rounded-full border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all shadow-sm text-slate-600"
          />
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 absolute left-4 top-[2.2rem] text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      </div>

      {filteredBlogs && filteredBlogs.length > 0 ? (
        <BlogList blogs={filteredBlogs} title={search ? `Search Results for "${search}"` : "All Blogs"} />
      ) : (
        <div className="text-center py-20 bg-slate-50 rounded-xl border-2 border-dashed border-slate-200">
          <p className="text-xl text-slate-500 font-medium">No blogs found matching your search.</p>
          {search && (
            <button 
              onClick={() => setSearch('')}
              className="mt-4 text-primary hover:text-rose-700 font-medium hover:underline"
            >
              Clear Search
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default Home